export default "__VITE_ASSET__4VYyXBKS__"